import { stdnum } from "stdnum";

export const isValidAbn = (value?: string): boolean => {
  if (!value) {
    return false;
  }
  const formatted = stdnum.AU.abn.format(value);
  return stdnum.AU.abn.validate(formatted).isValid;
};
